<template>
  <div>
    <div class="filter" style="border-bottom: 2px solid #335667">
      <el-form :model="filter" label-width="50px" label-position="top">
        <el-form-item label="年份">
          <el-date-picker
            size="small"
            type="years"
            value-format="yyyy"
            v-model="filter.years"
            placeholder="可多选"
            :picker-options="pickerOptions"
            :clearable="false"
            @change="getStatistics()"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="mt-20">
      <div>
        <el-table
          size="mini"
          max-height="400px"
          :data="tableData"
          v-loading="loading"
          stripe
          border
          sum-text="Total"
          :header-cell-style="{
            background: '#37717b',
            color: '#fff',
          }"
        >
          <el-table-column label="发起人" prop="name"></el-table-column>
          <el-table-column label="Total" align="right" prop="total">
          </el-table-column>
          <el-table-column label="占比" align="right" prop="percent">
          </el-table-column>
          <el-table-column
            :label="year"
            :prop="year"
            align="right"
            :key="year"
            v-for="year in getXAxis()"
          ></el-table-column>
        </el-table>
      </div>
      <div>
        <ve-line
          :extend="chartExtend"
          :colors="[
            '#37717b',
            '#84878f',
            '#ba956f',
            '#33486a',
            '#566a68',
            '#4a8764',
            '#9eb6c3',
            '#bfb0b6',
          ]"
        ></ve-line>
      </div>
    </div>
  </div>
</template>

<script>
import { serviceQuestStatistics } from '@/service/getData'

export default {
  computed: {
    tableData() {
      let flowUsers = this.groupBy(this.statistics, function (item) {
        return [item.user_id]
      })
      let total = 0
      let data = flowUsers.map((arr) => {
        let row = {
          name: arr[0].user.name || 'Customer',
          total: 0,
        }
        arr.map((item) => {
          row[item.format_date] = item.total
          row.total += item.total
          total += item.total
        })
        return row
      })

      data = data.map((d) => {
        d.percent = this.formatDivision(d.total, total)
        return d
      })
      return data
    },
    chartExtend() {
      let series = []
      let xAxis = this.getXAxis()
      let legendData = []
      this.tableData.map((item) => {
        let data = []
        xAxis.map((d) => {
          data.push(item[d] || 0)
        })
        series.push({ type: 'bar', name: item.name, data: data })
        legendData.push(item.name)
      })

      return {
        xAxis: {
          type: 'category',
          data: xAxis,
        },
        legend: {
          data: legendData,
          orient: 'horizontal',
          bottom: 10,
        },
        series: series,
      }
    },
  },
  data() {
    return {
      loading: false,
      statistics: [],
      filter: {
        featrue_type: 4, //统计维度
        date_type: 2, //时间颗粒度
        years: [new Date().getFullYear().toString()],
      },
      pickerOptions: {},
      years: [],
    }
  },
  created() {
    let that = this
    this.pickerOptions = {
      disabledDate: function (time) {
        return (
          that.$time(new Date()).isBefore(time) ||
          that.$time(time).isBefore('2025-01-01')
        )
      },
    }
    this.getStatistics()
  },
  methods: {
    async getStatistics() {
      if (this.filter.years.length == 0) {
        this.$alert('请至少选择一个年份!')
        return
      }
      if (this.filter.years.length > 0) {
        this.filter.years.sort()
      }
      let data = this.clone(this.filter)
      this.loading = true
      let res = await serviceQuestStatistics(data)
      this.years = this.filter.years
      this.statistics = res.data
      this.loading = false
    },
    formatDivision(a, b) {
      const result = (a / b) * 100
      if (Number.isInteger(result)) {
        return result + '%' // 或者使用 Math.floor(result)
      } else {
        return parseFloat(result.toFixed(1)) + '%'
      }
    },
    getXAxis() {
      let rowNames = []
      for (let index = 0; index < this.years.length; index++) {
        const year = this.years[index]
        if (year > new Date().getFullYear()) {
          break
        }
        if (this.filter.date_type == 1) {
          rowNames.push(year)
        } else {
          for (let idx = 1; idx <= 12; idx++) {
            let month = idx < 10 ? `0${idx}` : idx.toString()
            let name = year + '-' + month
            rowNames.push(name)
            if (name == this.$time(new Date()).format('YYYY-MM')) {
              break
            }
          }
        }
      }
      return rowNames
    },
  },
}
</script>